import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledWorks } from "./works.styled";
import { useWorkOptions } from "./works.data";
import { useWorkStructures } from "./useWorkStructures";
import { useWorksBrowse } from "./useWorksBrowse";
import { useWorksNavigation } from "./useWorksNavigation";

function Works() {
  const theme = useTheme();
  const { tableStructure } = useWorkStructures();
  const browse = useWorksBrowse();
  const navigation = useWorksNavigation();
  const workOptions = useWorkOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledWorks>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.workSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={workOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledWorks>
  );
}

export default Works;
